export default {"id":"479fd3b9","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}